import { render } from "./GridManagement.vue?vue&type=template&id=ab731b48&ts=true"
import script from "./GridManagement.vue?vue&type=script&lang=ts"
export * from "./GridManagement.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__